import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { InfoPlate, InfoPlateVariant } from "fe-shared/src/components";

import { InvoiceStatusCode } from "fe-shared-transactions/src/types";
import { INVOICE_STATUSES_CONFIG_MAP } from "consts";

import styles from "./InvoiceStatusPlate.module.scss";

interface Props {
  statusCode: InvoiceStatusCode;
  className?: string;
}

export type InvoiceStatusesConfigMap = {
  [key in InvoiceStatusCode]?: InfoPlateVariant;
};

export const InvoiceStatusPlate = (props: Props) => {
  const { t } = useTranslation();
  const { statusCode, className } = props;
  const variant = statusCode && INVOICE_STATUSES_CONFIG_MAP[statusCode];

  return statusCode && variant ? (
    <div className={classnames(styles.status, className)}>
      <InfoPlate variant={variant}>
        {t(`invoices.statuses.${statusCode}`)}
      </InfoPlate>
    </div>
  ) : (
    <div />
  );
};

export default InvoiceStatusPlate;
